/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";

import * as types from "./mutation-types";
import * as actions from "./actions";
import * as getters from "./getters";
import { ledgerHDPaths, coins } from "./constants";
Vue.use(Vuex);

const state = {
  activeBackendName: "",
  activeBackend: {},
  validBackend: "",
  backendConfig: {
    ledgerHDPaths,
    coins,
  },
};

const mutations = {
  [types.SET_ACTIVE_BACKEND_NAME](state, backendName) {
    state.activeBackendName = backendName;
  },
  [types.SET_ACTIVE_BACKEND](state, backend) {
    state.activeBackend = backend;
  },
  [types.SET_VALID_BACKEND](state, backendMsg) {
    state.validBackend = backendMsg;
  },
  [types.CLEAN_UP_BACKEND](state) {
    "function" === typeof state.activeBackend.cleanUp &&
      state.activeBackend.cleanUp();
    state.activeBackendName = "";
    state.activeBackend = {};
    state.validBackend = "";
  },
};

export const module = {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
};

export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
});
